var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{attrs:{"title":_vm.headerTitle,"items":_vm.headerItems}}),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-8 mb-3 mb-lg-9"},[_c('product-info'),_c('product-pictures')],1),_c('div',{staticClass:"col-lg-4"},[_c('product-price'),_c('product-organization')],1)]),_c('save-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }